import { render, staticRenderFns } from "./SinglePspMethod.vue?vue&type=template&id=aa074ae6&scoped=true"
import script from "./SinglePspMethod.vue?vue&type=script&lang=js"
export * from "./SinglePspMethod.vue?vue&type=script&lang=js"
import style0 from "./SinglePspMethod.vue?vue&type=style&index=0&id=aa074ae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa074ae6",
  null
  
)

export default component.exports